import {
  api,
  CertificationStatusHistory,
  CertificationStatusLastChangeResponse,
  GetOnlineSpeakingStatusHistoryParams,
  OnlineSpeakingStatusHistoryResult,
  PagedResultOfCertificationStatusHistory,
} from 'api';
import { queryCacheDuration } from 'const';
import { rtkQueryApi } from 'store/rtkQueryApi';
import { TableState } from 'types';
import { CertificationStatusHistoryFilterType } from './certificationStatusHistoryTypes';
import { getPaginationParameters, getQueryStringParameters } from 'utils';

export interface GetCertificationStatusLastChangeParams {
  examinerId: number;
}

type CertificationStatusHistoryListParams = TableState<
  CertificationStatusHistory,
  CertificationStatusHistoryFilterType
>;

export const certificationStatusHistoryApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getCertificationStatusLastChange: builder.query<
      CertificationStatusLastChangeResponse,
      GetCertificationStatusLastChangeParams
    >({
      query: ({ examinerId }) => {
        return api.certificationStatusHistory.getCertificationStatusLastChange({
          examinerId,
        });
      },
      keepUnusedDataFor: queryCacheDuration,
      providesTags: ['ExaminerStatus'],
    }),

    getExaminerStatusHistory: builder.query<
      PagedResultOfCertificationStatusHistory,
      CertificationStatusHistoryListParams
    >({
      query: (params) => {
        const input = getQueryStringParameters({
          ...getPaginationParameters(params),
          filter: params.filters,
        });
        return api.examinerCertificationStatus.getExaminerStatusHistory(input);
      },
      providesTags: ['ExaminerStatus', 'Examiner'],
    }),

    getOnlineSpeakingStatusHistory: builder.query<
      OnlineSpeakingStatusHistoryResult[],
      GetOnlineSpeakingStatusHistoryParams
    >({
      query: ({ examinerId }) =>
        api.examinerCertificationStatus.getOnlineSpeakingStatusHistory({ examinerId }),
      providesTags: ['ExaminerStatus', 'Examiner'],
    }),
  }),
});

export const {
  useGetCertificationStatusLastChangeQuery,
  useGetExaminerStatusHistoryQuery,
  useGetOnlineSpeakingStatusHistoryQuery,
} = certificationStatusHistoryApi;
